import React from 'react';
import styles from './NavList.scss';
import classNames from 'classnames';
import { NavigationItemType } from '../../mobile-menu-item/itemTypes';

export const NavList = ({
  inlineChild,
  itemType = NavigationItemType.DEFAULT,
  testid,
  children,
}: {
  inlineChild?: boolean;
  itemType: NavigationItemType;
  testid?: string;
  children: React.ReactNode;
}) => {
  return (
    <ul
      data-testid={testid}
      className={classNames(styles.list, {
        [styles.listImageGrid]: itemType === NavigationItemType.IMAGE_GRID,
        [styles.listImageRow]: itemType === NavigationItemType.IMAGE_ROW,
        [styles.listBrandLogos]: itemType === NavigationItemType.BRAND_LOGOS,
        [styles.listExtras]: itemType === NavigationItemType.EXTRAS,
        [styles.listInlineChild]: inlineChild,
      })}
    >
      {React.Children.toArray(children).map((child, index) => (
        <li
          key={`nav-list-item-${testid}-${index}`}
          className={styles.listItem}
        >
          {child}
        </li>
      ))}
    </ul>
  );
};
